import GET_CLUSTERS from './getClusters.graphql'

export { GET_CLUSTERS }
